import VerifiedIcon from '@mui/icons-material/Verified'
import HandshakeIcon from '@mui/icons-material/Handshake'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'

// الصور - غيّرها بصور حقيقية لصفحة الأباوت لو حابب
import aboutHeroImg from '../Images/homeimage.webp'
import storyImg from '../Images/img50-1-e1706774753450.webp'

/**
 * aboutUsData
 * كل محتوى صفحة الأباوت في مكان واحد - عدّل النصوص والأرقام من هنا بس
 * من غير ما تلمس أي JSX في صفحة AboutUsPages
 */
export const aboutUsData = {
  hero: {
    image: aboutHeroImg,
    eyebrow: { en: 'Who We Are', ar: 'من نحن' },
    title: { en: 'Building Trust, One Property at a Time', ar: 'نبني الثقة عقار بعقار' },
    subtitle: {
      en: 'Your trusted partner in the Dubai real estate market — whether you\'re investing, buying a home, or renting. Backed by years of experience and complete transparency in every deal.',
      ar: 'شريكك الموثوق في سوق العقارات بدبي — سواء بتستثمر، بتشتري سكن، أو بتأجر. بخبرة سنين وشفافية كاملة في كل صفقة.',
    },
  },

  story: {
    image: storyImg,
    eyebrow: { en: 'Our Story', ar: 'قصتنا' },
    title: { en: 'A Journey Built on Passion for Real Estate', ar: 'رحلة بدأت بشغف نحو العقارات' },
    paragraphs: [
      {
        en: 'We started our journey in Dubai\'s real estate market with one goal: helping investors, homebuyers, and tenants make informed, confident decisions. Over the years, we built strong relationships with leading developers and earned a reputation built on trust and transparency.',
        ar: 'بدأنا رحلتنا في سوق دبي العقاري بهدف واحد: مساعدة المستثمرين، والباحثين عن سكن، والمستأجرين ياخدوا قرارات واعية وسليمة. مع مرور السنين، بنينا شبكة علاقات قوية مع أفضل المطورين، وبنينا سمعة قائمة على الثقة والشفافية.',
      },
      {
        en: 'Today, our team is proud to have helped hundreds of clients reach their goals — whether it\'s a profitable investment, a dream home, or a smart rental. And we remain committed to the same values we started with.',
        ar: 'دلوقتي، فريقنا فخور بمساعدة مئات العملاء يوصلوا لأهدافهم — سواء استثمار مربح، منزل أحلام، أو وحدة للإيجار. ونفضل نلتزم بنفس القيم اللي بدأنا بيها.',
      },
    ],
    ctaLabel: { en: 'Get in Touch', ar: 'تواصل معنا' },
  },

  stats: [
    { value: '10+', label: { en: 'Years of Experience', ar: 'سنوات من الخبرة' } },
    { value: '500+', label: { en: 'Properties Sold', ar: 'عقار مباع' } },
    { value: '15+', label: { en: 'Developer Partners', ar: 'شريك تطوير عقاري' } },
    { value: '98%', label: { en: 'Client Satisfaction', ar: 'رضا العملاء' } },
  ],

  valuesSection: {
    eyebrow: { en: 'Our Values', ar: 'قيمنا' },
    title: { en: 'What Sets Us Apart', ar: 'إيه اللي يميزنا' },
    items: [
      {
        icon: VerifiedIcon,
        title: { en: 'Trust & Transparency', ar: 'الثقة والشفافية' },
        desc: {
          en: 'Every deal is built on clear terms and honest advice, from the first meeting to the final handover.',
          ar: 'كل صفقة مبنية على شروط واضحة ونصيحة صادقة، من أول لقاء لحد التسليم النهائي.',
        },
      },
      {
        icon: TrendingUpIcon,
        title: { en: 'Market Expertise', ar: 'خبرة السوق' },
        desc: {
          en: 'Deep knowledge of Dubai\'s real estate market helps our clients make informed, profitable decisions — whether for investment, living, or rental.',
          ar: 'معرفة عميقة بسوق العقارات في دبي بتساعد عملاءنا ياخدوا قرارات واعية ومربحة — سواء للاستثمار، السكن، أو الإيجار.',
        },
      },
      {
        icon: HandshakeIcon,
        title: { en: 'Client Partnership', ar: 'شراكة حقيقية مع العميل' },
        desc: {
          en: 'We see every client as a long-term partner, not a one-time transaction — before, during, and after the deal.',
          ar: 'بنشوف كل عميل شريك على المدى الطويل، مش مجرد صفقة عابرة — قبل وأثناء وبعد الصفقة.',
        },
      },
      {
        icon: SupportAgentIcon,
        title: { en: 'End-to-End Support', ar: 'دعم كامل في كل خطوة' },
        desc: {
          en: 'From choosing the property to financing, contracts, handover, and even property management — we\'re with you the whole way.',
          ar: 'من اختيار العقار لحد التمويل والعقود والتسليم، وحتى إدارة الأملاك — معاك في كل خطوة.',
        },
      },
    ],
  },
}